import React, { useEffect } from 'react';

interface ClassroomModalProps {
  isOpen: boolean;
  title: string;
  onClose: () => void;
  children: React.ReactNode;
  width?: number | string;
}

const ClassroomModal: React.FC<ClassroomModalProps> = ({
  isOpen,
  title,
  onClose,
  children,
  width = 420,
}) => {
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="cd-modal-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
      role="presentation"
    >
      <div
        className="cd-modal"
        style={{ maxWidth: width }}
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        <div className="cd-modal-head">
          <h3 className="cd-modal-title">{title}</h3>
          <button type="button" className="cd-modal-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>
        <div className="cd-modal-body">{children}</div>
      </div>
    </div>
  );
};

export default ClassroomModal;
